import api, { ApiResponse } from './api'
import type { CheckoutSession, CreateCheckoutRequest } from '../types'

export function createCheckoutSession(data: CreateCheckoutRequest): Promise<ApiResponse<CheckoutSession>> {
  return api.post('/v1/merchant/checkouts', data)
}

export function getCheckoutSession(id: string): Promise<ApiResponse<CheckoutSession>> {
  return api.get(`/v1/merchant/checkouts/${id}`)
}
